class WLSSearchForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.setupFormEventListeners();

    this.classes = {
      loading: 'loading',
    };
  }

  setupFormEventListeners() {
    if (!this.input || !this.form) return;

    this.input.addEventListener('input', (e) => {
      const value = e.target.value;
      document.querySelectorAll('wls-search-form input[type="search"]').forEach((input) => {
        if (input !== e.target) {
          input.value = value;
        }
      });
    });

    this.form.addEventListener('reset', () => {
      this.input.value = '';
      this.input.focus();
      document.querySelectorAll('wls-search-form input[type="search"]').forEach((input) => {
        if (input !== this.input) {
          input.value = '';
        }
      });
    });

    if (this.resetButton) {
      this.resetButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.input.value = '';
        this.input.focus();
        document.querySelectorAll('wls-search-form input[type="search"]').forEach((input) => {
          if (input !== this.input) {
            input.value = '';
          }
        });
      });
    }
  }

  setLoading() {
    this.setAttribute('disabled', true);
    this.classList.add(this.classes.loading);
  }

  removeLoading() {
    this.removeAttribute('disabled');
    this.classList.remove(this.classes.loading);
  }
}

if (!customElements.get('wls-search-form')) {
  customElements.define('wls-search-form', WLSSearchForm);
}
